/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export enum PricingModel {
  Fixed,
  Hourly,
  PerTask,
  Subscription,
  Auction,
  Dynamic,
  RevenueShare,
  Tiered,
}

export type PricingModelArgs = PricingModel;

export function getPricingModelEncoder(): FixedSizeEncoder<PricingModelArgs> {
  return getEnumEncoder(PricingModel);
}

export function getPricingModelDecoder(): FixedSizeDecoder<PricingModel> {
  return getEnumDecoder(PricingModel);
}

export function getPricingModelCodec(): FixedSizeCodec<
  PricingModelArgs,
  PricingModel
> {
  return combineCodec(getPricingModelEncoder(), getPricingModelDecoder());
}
